import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function A1z26() {
  const [includeÑ, setIncludeÑ] = useState(true);
  const [text, setText] = useState("");
  const [code, setCode] = useState("");

  const alphabetA1Z26 = {
    A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, I: 9,
    J: 10, K: 11, L: 12, M: 13, N: 14, O: 15, P: 16,
    Q: 17, R: 18, S: 19, T: 20, U: 21, V: 22, W: 23, X: 24, Y: 25, Z: 26, " ": "/"
  };

  const alphabetA1Z27 = {
    A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, I: 9,
    J: 10, K: 11, L: 12, M: 13, N: 14, Ñ: 15, O: 16, P: 17,
    Q: 18, R: 19, S: 20, T: 21, U: 22, V: 23, W: 24, X: 25, Y: 26, Z: 27, " ": "/"
  };

  const alphabet = includeÑ ? alphabetA1Z27 : alphabetA1Z26;
  const inverseAlphabet = Object.fromEntries(Object.entries(alphabet).map(([k, v]) => [v.toString(), k]));

  const textToCode = (input) =>
    input
      .toUpperCase()
      .split("")
      .map((char) => alphabet[char] ?? "")
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();

  const codeToText = (input) => {
    const trimmed = input.trim();
    const words = trimmed.split("/");
    const result = words
    .map(word => 
      word
        .trim()
        .split(" ")
        .filter(num => num !== "")
        .map(num => inverseAlphabet[num] ?? "▯")
        .join("")
      )
     .join(" "); 
    return result;
  };

useEffect(() => {
  if (document.activeElement.name === "text") {
    setCode(textToCode(text));
  } else if (document.activeElement.name === "code") {
    setText(codeToText(code));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [text, code, includeÑ]);

  const AlphabetTable = ({ alphabet, alphabetTitle }) => {
    const entries = Object.entries(alphabet).filter(([key]) => key !== " ");
    const rows = [];
    for (let i = 0; i < entries.length; i += 3) {
      rows.push(entries.slice(i, i + 3));
    }

    return (
      <table>
        <caption className="table-title">{alphabetTitle}</caption>
        <tbody>
          {rows.map((group, i) => (
            <tr key={i}>
              {group.map(([letter, value]) => (
                <React.Fragment key={letter}>
                  <td>{letter}</td>
                  <td>=</td>
                  <td className="code">{value}</td>
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>A1Z26 | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="a1z26" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">A1Z26</h1>
          <p className="subtitle">A1Z26 es un cifrado de sustitución muy simple, donde cada letra del alfabeto se reemplaza por su número en el alfabeto.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="code">{includeÑ?"A1z27":"A1z26"}</label>
              <textarea id="input-code" className="input-left" name="code" value={code} spellCheck="false"
                onChange={(e) => {
                  const clean = e.target.value.replace(/[^0-9 /]/g, "");
                  setCode(clean);
                }}
              />
              <span className="info info-left">Carácteres permitidos: Números, espacio y /</span>
              <div className="option">
                <label htmlFor="include-ñ">Incluir Ñ</label>
                <input type="checkbox" id="include-ñ" name="include-ñ" checked={includeÑ} onChange={() => {setIncludeÑ((v) => !v);setText("");setCode("");}}/>
              </div>
              <div className="buttons">
                <button className="btn btn-primary" onClick={() => setCode(textToCode(text))}><span>Cifrar </span><i className="fas fa-arrow-right"></i></button>
                <button className="btn btn-primary" onClick={() => setText(codeToText(code))}><i className="fas fa-arrow-left"></i><span> Descrifrar</span></button>
              </div>
              <label className="text-right" htmlFor="text">Texto</label>
              <textarea id="input-text" className="input-right" name="text" value={text} spellCheck="false"
                onChange={(e) => {
                  const clean = e.target.value.replace(/[^a-zA-ZÑñ ]/g, "").toUpperCase();
                  setText(clean);
                  }}
                />
                <span className="info info-right">Carácteres permitidos: Letras y espacio</span>
            </div>
          </div>
          <div className="content-table">
            <div className="table-wrapper">
              <AlphabetTable alphabet={alphabetA1Z26} alphabetTitle="Alfabeto Español" />
            </div>
            <div className="table-wrapper">
              <AlphabetTable alphabet={alphabetA1Z27} alphabetTitle="Alfabeto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
